import styled from '@emotion/styled';
import {
  Button,
  DialogActions,
  DialogContent as _DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import { List } from 'immutable';
import { ClassAttributes, createElement, FC, MouseEvent, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import YahooAdAccount from '../../../entity/YahooAdAccount';
import { SPACING_REGULAR } from '../../constant/spacing';
import Dialog from '../primitive/DialogWithPadding';
import YahooAdAccountList from './YahooAdAccountList';

type Props = ClassAttributes<HTMLElement> & {
  yahooAdAccounts: List<YahooAdAccount>;
  open: boolean;
  onRequestSendingCreative: (e: MouseEvent<HTMLElement>, yahooAdAccount: YahooAdAccount) => void;
  onRequestClose: () => void;
  className?: string;
};

const IntegrateYahooAdAccountDialog: FC<Props> = ({
  yahooAdAccounts,
  open,
  onRequestSendingCreative,
  onRequestClose,
  className,
}) => {
  const [selectedAdAccount, setSelectedAdAccount] = useState<YahooAdAccount | null>(null);
  const onClickAdAccount = (_: any, selected: YahooAdAccount) => setSelectedAdAccount(selected);
  const onClickSendButton = async (e: any) => {
    if (selectedAdAccount !== null) {
      await onRequestSendingCreative(e, selectedAdAccount);
    }
    onRequestClose();
  };

  return (
    <Dialog open={open} onRequestClose={onRequestClose} className={className} maxWidth="md">
      <DialogTitle disableTypography>
        <Typography variant="h6">
          <FormattedMessage id="integrate_yahoo_ad_account_dialog.title" />
        </Typography>
        <Description>
          <FormattedMessage id="integrate_yahoo_ad_account_dialog.description" />
        </Description>
      </DialogTitle>

      <ContentLayout>
        <DialogContent>
          <YahooAdAccountList
            yahooAdAccounts={yahooAdAccounts}
            selected={selectedAdAccount}
            onClick={onClickAdAccount}
          />
        </DialogContent>
      </ContentLayout>

      <DialogActions>
        <Button disabled={!selectedAdAccount} onClick={onClickSendButton}>
          <FormattedMessage id="integrate_yahoo_ad_account_dialog.send" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const Description = styled(DialogContentText)({
  marginTop: SPACING_REGULAR,
});

const ContentLayout = styled('div')({
  display: 'flex',
  justifyContent: 'center',
});

const DialogContent = styled(_DialogContent)({
  paddingTop: '0 !important',
  paddingBottom: 0,
  maxWidth: 750,
});

export default IntegrateYahooAdAccountDialog;
